import getApiClient from "./../../../../shared/api";

export const FETCH_CHARACTER_COSTUMES = "FETCH_CHARACTER_COSTUMES";

export function fetchCharacterCostumes(filmId, characterId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_CHARACTER_COSTUMES,
      payload: getApiClient().get(`/film/${filmId}/character/${characterId}/costumes`)
    });
  };
}
